/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/domains/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, {useEffect} from "react";
import {Redirect, Switch, Route} from "react-router-dom";
import {connect, shallowEqual, useSelector} from "react-redux";
import {Layout} from "./layout";
import BasePage from "./BasePage";
import {Logout, AuthPage} from "./domains/auth";
import ErrorsPage from "./domains/errors/ErrorsPage";
import routes, {authRoutes} from './routes';
import {requestUser} from "../store/actions/session";

const AppRouter = ({requestUser}) => {
    const {isAuthorized, validateTwoFactorCode} = useSelector(
        ({auth}) => ({
            isAuthorized: auth.user != null,
            validateTwoFactorCode: auth.twoFactorUuid != null
        }),
        shallowEqual
    );

    // check user
    useEffect(() => {
        if (isAuthorized) {
            requestUser();
        }
    });

    return (
        <Switch>
            {!isAuthorized ? (
                /*Render auth page when user at `/auth` and not authorized.*/
                <Route>
                    <AuthPage isAuthorized={isAuthorized} validateTwoFactorCode={validateTwoFactorCode}/>
                </Route>
            ) : (
                /*Otherwise redirect to root page (`/`)*/
                <Redirect from={authRoutes.auth} to={routes.root}/>
            )}

            <Route path={routes.notFound}><ErrorsPage/></Route>
            <Route path={routes.logout}><Logout/></Route>

            {!isAuthorized ? (
                /*Redirect to `/auth` when user is not authorized*/
                <Redirect to={authRoutes.login}/>
            ) : (
                <Layout>
                    <BasePage/>
                </Layout>
            )}
        </Switch>
    );
}

const mapStateToProps = (state) => {
    return {};
}

export default connect(mapStateToProps, {requestUser})(AppRouter);
